module.exports = __webpack_public_path__ + "img/icon-checkmark-green.d92d4ef4.svg";